import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';
import { youtubeMap } from '@/constants/delta2max';
import NextImage from '@/components/NextImage';

export default function Z3() {
    const { useLang, useRouter, useState } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    return (
        <div id="durable-safe" className={`d2x-Z3 ${css.d2xZ3} GtmModuleData-section`} data-section-id={css.d2xZ3} data-section-title={t('sec3_title')}>
            <div className="sec3">
                <div className="text-box">
                    <p className="guide">{t('sec3_subtitle')}</p>
                    <p className="title">{t('sec3_title')}</p>
                    <p className="desc">{t('sec3_desc')}</p>
                </div>
                <div className="img-box">
                    <NextImage
                        webpSrc={
                            locale === 'cn'
                                ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717659209081/10_years_cn_pc.jpg'
                                : require(`@publicLocal/delta2max/teaser/pc/eu/3${['de', 'fr', 'it', 'es', 'jp'].includes(locale) ? `_${locale}` : ''}.webp`)
                        }
                        src={
                            locale === 'cn'
                                ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717659209081/10_years_cn_pc.jpg'
                                : require(`@publicLocal/delta2max/teaser/pc/eu/3${['de', 'fr', 'it', 'es', 'jp'].includes(locale) ? `_${locale}` : ''}.jpg`)
                        }
                        alt={t('sec3_title')}
                        aria-label={t('sec3_title')}
                    />
                </div>
                {locale === 'cn' && <p className="sec3-memo">{t('sec4_memo')}</p>}
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={youtubeMap[locale] || youtubeMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
